import React from "react";
import Typography from "material-ui/Typography";
import Grid from "material-ui/Grid";
import TextField from "material-ui/TextField";
import Icon from "material-ui/Icon";
import IconButton from "material-ui/IconButton";
import Button from "material-ui/Button";
import Title from "../../ui/title";
import Content from "../../ui/content";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import SearchTarget from "../common/searchTarget";
import ConfirmDialog from "../../common/dialog/confirm";
import Back from "../../ui/back";
import BackCheck from "../../ui/backCheck";
import { withRouter } from "react-router-dom";
import { validateFormData, validateTargetData } from "../../../common/formtool";

import NoData from "../../nodata";

class Ping extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pingErrors: {},
      logo: null,
      selectedTestResult: null,

      subTestTargetResult: this.props.isTestEdit
        ? this.props.subTestTargetResult
        : null,
      isChanged: false,
      searchModal: null,
      oldSelectedTargetId: null,
      oldSelectedTargetKey: null,
      showConfirmDelete: false,
      showConfirmBack: false,
      deleteTargetId: null,
      selectedTest: null,
      subTestPingUpdated: this.props.subTestPingUpdated,
      //showRestore: this.props.isDetailsUpdated ? true : false,
      showRestoreConfirm: false,
      backupSelectedTestResult: "",
      // isDetailsUpdated: this.props.isDetailsUpdated
      //   ? this.props.isDetailsUpdated
      //   : false,
      isRestore: false,
      isPingUpdated: false
    };
    this.onChange = this.onChange.bind(this);
    this.onTargetEdit = this.onTargetEdit.bind(this);
    this.onTargetConfirmDelete = this.onTargetConfirmDelete.bind(this);
    this.hideConfirmModal = this.hideConfirmModal.bind(this);
    this.onTargetSearchSelect = this.onTargetSearchSelect.bind(this);
    this.onTargetSave = this.onTargetSave.bind(this);
    this.onBackClick = this.onBackClick.bind(this);
    this.onBackYesClick = this.onBackYesClick.bind(this);
    this.onBackNoClick = this.onBackNoClick.bind(this);
    this.hideBackConfirmModal = this.hideBackConfirmModal.bind(this);
    //this.testing = this.testing.bind(this);
  }
  componentWillMount() {
    const {
      ping4Details,
      ping6Details,
      isTestEdit,
      selectedTest,
      testEdit,
      modified
    } = this.props;
    if (isTestEdit) {
      this.props.getPingTargetList(this.props.customerId);
    } else {
      this.props.getPingTargetList(null);
    }

    if (testEdit) {
      const { sessionStorage } = window;
      if (
        isTestEdit &&
        selectedTest.includes("ping4") &&
        !modified &&
        ping4Details
      ) {
        sessionStorage.setItem("PING4DEFAULT", JSON.stringify(ping4Details));
      } else if (
        isTestEdit &&
        selectedTest.includes("ping6") &&
        !modified &&
        ping6Details
      ) {
        sessionStorage.setItem("PING6DEFAULT", JSON.stringify(ping6Details));
      } else if (!isTestEdit) {
        this.props.getPingDetails(this.props.selectedTest);
      } else {
        if (isTestEdit && selectedTest.includes("ping4") && !ping4Details) {
          this.props.getPingDetails(this.props.selectedTest);
        } else if (
          isTestEdit &&
          selectedTest.includes("ping6") &&
          !ping6Details
        ) {
          this.props.getPingDetails(this.props.selectedTest);
        } else if (!isTestEdit) {
          this.props.getPingDetails(this.props.selectedTest);
        }
      }
    } else {
      if (isTestEdit && selectedTest.includes("ping4") && !ping4Details) {
        this.props.getPingDetails(this.props.selectedTest);
      } else if (
        isTestEdit &&
        selectedTest.includes("ping6") &&
        !ping6Details
      ) {
        this.props.getPingDetails(this.props.selectedTest);
      } else if (!isTestEdit) {
        this.props.getPingDetails(this.props.selectedTest);
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    const {
      selectedTestResult,
      subTestTargetResult,
      selectedTest,
      isTestEdit,
      ping4Details,
      ping6Details
    } = nextProps;
    const { isPingUpdated } = this.state;
    if (
      selectedTestResult &&
      this.props.selectedTestResult != selectedTestResult
    ) {
      //const backupSelectedTestResult = selectedTestResult;
      this.setState({
        selectedTestResult
      });
      if (isTestEdit) {
        const { sessionStorage } = window;
        if (
          selectedTest.includes("ping4") &&
          selectedTestResult.type.toLowerCase().includes("ping4")
        ) {
          sessionStorage.setItem(
            "PING4DEFAULT",
            JSON.stringify(selectedTestResult)
          );
        } else if (
          selectedTest.includes("ping6") &&
          selectedTestResult.type.toLowerCase().includes("ping6")
        ) {
          sessionStorage.setItem(
            "PING6DEFAULT",
            JSON.stringify(selectedTestResult)
          );
        }
      }
    }

    if (
      subTestTargetResult &&
      this.props.subTestTargetResult != subTestTargetResult
    ) {
      this.setState({
        subTestTargetResult: subTestTargetResult
      });
    }

    if (isTestEdit) {
      if (
        (this.props.selectedTest == "ping4" &&
          ping4Details &&
          ping4Details !== this.props.ping4Details) ||
        (ping4Details && !isPingUpdated)
      ) {
        this.setState({
          selectedTestResult: ping4Details,
          isPingUpdated: true
        });
      } else if (
        (this.props.selectedTest == "ping6" &&
          ping6Details &&
          ping6Details !== this.props.ping6Details) ||
        (ping6Details && !isPingUpdated)
      ) {
        this.setState({
          selectedTestResult: ping6Details,
          isPingUpdated: true
        });
      }
    }
  }

  componentWillUpdate(prevProps, prevState) {
    if (this.props.isTestEdit) {
      const { subTestTargetResult, trErrors, selectedTestResult } = this.props;
      if (
        selectedTestResult &&
        prevProps.selectedTestResult != selectedTestResult
      ) {
        this.setState({
          selectedTestResult,
          trErrors: trErrors
        });
      }
      // if (
      //   subTestTargetResult &&
      //   prevProps.subTestTargetResult != subTestTargetResult
      // ) {
      //   this.setState({
      //     subTestTargetResult: subTestTargetResult
      //   });
      // }
    }
  }

  componentWillUnmount() {
    this.setState({ selectedTestResult: null, subTestTargetResult: null });
  }

  onChange(e) {
    let selectedTestResult = { ...this.state.selectedTestResult };

    let pingErrors = { ...this.state.pingErrors };
    pingErrors = {
      ...pingErrors,
      [e.target.name]: false
    };

    selectedTestResult[e.target.name] =
      e.target.value == 0
        ? e.target.value
        : Number(e.target.value)
        ? Number(e.target.value)
        : "";

    this.setState({
      pingErrors,
      selectedTestResult: selectedTestResult,
      isChanged: true,
      showRestore: false,
      isRestore: false
    });
  }

  onTargetEdit = keyValue => e => {
    const { translate, selectedTest } = this.props;
    const { selectedTestResult } = this.state;
    const selectedTestResultTargets = [
      ...this.state.selectedTestResult.targets
    ];
    let pingErrors = { ...this.state.pingErrors };
    let vObj = {};
    //selectedTestResultTargets[keyValue].name = e.target.value;
    selectedTestResultTargets[keyValue] = {
      ...selectedTestResultTargets[keyValue],
      name: e.target.value
    };
    vObj[keyValue] = {
      maxLength: {
        value: 256,
        message: translate("subtest_target_length_validation", {
          value: 256
        })
      }
    };
    let pingError = validateTargetData(
      selectedTestResult.targets,
      vObj,
      selectedTest
    );
    if (Object.keys(pingError).length) {
      pingErrors = {
        ...pingErrors,
        [keyValue]: pingError[keyValue]
      };
      this.setState({
        // ...this.state.selectedTestResult,
        // targets: selectedTestResultTargets,
        pingErrors,
        isChanged: false,
        isRestore: false
      });
      this.setState(prevState => ({
        selectedTestResult: {
          ...prevState.selectedTestResult, // copy all other key-value pairs of food object
          targets: selectedTestResultTargets
        }
      }));
    } else {
      pingErrors = {
        ...pingErrors,
        [keyValue]: false
      };
      this.setState({
        // ...this.state.selectedTestResult,
        // targets: selectedTestResultTargets,
        pingErrors,
        isChanged: true,
        showRestore: false,
        isRestore: false
      });
      this.setState(prevState => ({
        selectedTestResult: {
          ...prevState.selectedTestResult, // copy all other key-value pairs of food object
          targets: selectedTestResultTargets
        }
      }));
    }
  };

  onTargetDelete = key => {
    this.setState({
      showConfirmDelete: true,
      deleteTargetId: key,
      showRestore: false
    });
  };

  onTargetConfirmDelete = () => {
    const { selectedTestResult } = this.state;
    //let finalTargets = this.state.selectedTestResult.targets;
    let finalTargets = [...this.state.selectedTestResult.targets];
    let pingErrors = { ...this.state.pingErrors };
    finalTargets.splice(this.state.deleteTargetId, 1);
    for (let i = 0; i < 10; i++) {
      if (pingErrors.hasOwnProperty(i)) delete pingErrors[i];
    }
    this.setState({
      // selectedTestResult: {
      //   ...this.state.selectedTestResult,
      //   targets: finalTargets
      // },
      pingErrors,
      isChanged: true,
      showRestore: false,
      isRestore: false
    });
    this.setState(prevState => ({
      selectedTestResult: {
        ...prevState.selectedTestResult, // copy all other key-value pairs of food object
        targets: finalTargets
      }
    }));

    this.hideConfirmModal();
  };

  hideConfirmModal() {
    this.setState({
      showConfirmDelete: false
    });
  }
  onTargetAdd = () => {
    const { selectedTestResult } = this.state;
    //let finalTargets = this.state.selectedTestResult.targets;
    let finalTargets = [...this.state.selectedTestResult.targets];
    finalTargets.push({ id: 0 });
    this.setState({
      // selectedTestResult: {
      //   ...this.state.selectedTestResult,
      //   targets: finalTargets
      // },
      errors: {},
      isChanged: true,
      showRestore: false
    });
    this.setState(prevState => ({
      selectedTestResult: {
        ...prevState.selectedTestResult, // copy all other key-value pairs of food object
        targets: finalTargets
      }
    }));
  };

  onTargetSave = () => {
    let selectedTestResult = { ...this.state.selectedTestResult };
    let { translate, selectedTest, isTestEdit } = this.props;
    this.setState(
      {
        isChanged: true
      },
      () => {
        let vObj = {
          count: {
            required: translate("formfield_error_general_required"),
            range: {
              minValue: 1,
              maxValue: 999999,
              message: translate("sub_test_ping_validation_range", {
                name: "Count",
                value1: 1,
                value2: 999999
              })
            }
          },
          pause: {
            required: translate("formfield_error_general_required"),
            range: {
              minValue: 10,
              maxValue: 5000,
              message: translate("sub_test_ping_validation_range", {
                name: "Pause",
                value1: 10,
                value2: 5000
              })
            }
          },
          length: {
            required: translate("formfield_error_general_required"),
            range: {
              minValue: 8,
              maxValue: 3000,
              message: translate("sub_test_ping_validation_range", {
                name: "Length",
                value1: 8,
                value2: 3000
              })
            }
          }
        };

        let pingErrors = validateFormData(selectedTestResult, vObj);
        const missingFieldName = Object.keys(pingErrors)[0];
        if (missingFieldName) {
          const textField = document.getElementsByName(missingFieldName)[0];
          textField && textField.focus();
        }

        let vObj2 = {};
        selectedTestResult.targets.forEach(function(item, index) {
          vObj2[index] = {
            required: translate("formfield_error_general_required"),
            maxLength: {
              value: 256,
              message: translate("subtest_target_length_validation", {
                value: 256
              })
            }
          };
        });

        let pingErrors2 = validateTargetData(
          selectedTestResult.targets,
          vObj2,
          selectedTest
        );
        pingErrors = {
          ...pingErrors,
          ...pingErrors2
        };
        if (Object.keys(pingErrors).length) {
          this.setState({ pingErrors: pingErrors });
        } else {
          let self = this;
          isTestEdit
            ? this.props.updateTestPingDetails(selectedTest, selectedTestResult)
            : this.props.updatePingDetails(selectedTest, selectedTestResult);
          if (this.state.isRestore) {
            this.props.deleteDefaultSubtests(selectedTest);
          }
          if (this.props.isTestEdit) {
            this.props.handleClose();
          }
          this.setState({
            isChanged: false,
            showRestore: true
          });
        }
      }
    );
  };

  onTargetSearchOpen = (id, key) => {
    this.setState({
      searchModal: true,
      oldSelectedTargetId: id,
      oldSelectedTargetKey: key
    });
  };

  onTargetSearchClose = () => {
    this.setState({
      searchModal: false,
      oldSelectedTargetId: null,
      oldSelectedTargetKey: null
    });
  };

  onTargetSearchSelect = selectedTarget => {
    let pingErrors = { ...this.state.pingErrors };
    pingErrors = {
      ...pingErrors,
      [this.state.oldSelectedTargetKey]: false
    };
    let selectedTestResultT = [...this.state.selectedTestResult.targets];
    if (this.state.oldSelectedTargetId == 0) {
      selectedTestResultT[this.state.oldSelectedTargetKey].id =
        selectedTarget.id;
      selectedTestResultT[this.state.oldSelectedTargetKey].name =
        selectedTarget.url;
    } else {
      selectedTestResultT.map(obj => {
        if (obj.id == this.state.oldSelectedTargetId) {
          obj.id = selectedTarget.id;
          obj.name = selectedTarget.url;
        }
      });
    }
    this.setState({
      pingErrors: pingErrors,
      searchModal: false,
      oldSelectedTargetId: null,
      isChanged: true,
      showRestore: false,
      isRestore: false
    });
    this.setState(prevState => ({
      selectedTestResult: {
        ...prevState.selectedTestResult, // copy all other key-value pairs of food object
        targets: selectedTestResultT
      }
    }));
  };

  onBackClick = () => {
    if (this.state.isChanged) {
      this.setState({
        showConfirmBack: true
      });
    }
  };
  onBackYesClick = () => {
    this.onTargetSave();
    this.setState({
      showConfirmBack: false
    });
  };
  onBackNoClick = () => {
    this.props.history.push("/subtestsettings");
  };
  hideBackConfirmModal = () => {
    this.setState({
      showConfirmBack: false
    });
  };
  onResetDetails = () => {
    this.setState({
      showRestoreConfirm: true
    });
  };
  hideRestoreConfirmModal = () => {
    this.setState({
      showRestoreConfirm: false
    });
  };
  onRestoreConfirm = () => {
    const { selectedTest } = this.props;
    let defaultValue = null;
    const { sessionStorage } = window;
    if (selectedTest.includes("ping4")) {
      defaultValue = JSON.parse(sessionStorage.getItem("PING4DEFAULT"));
    } else if (selectedTest.includes("ping6")) {
      defaultValue = JSON.parse(sessionStorage.getItem("PING6DEFAULT"));
    }
    //this.props.updateTestPingDetails(selectedTest, defaultValue);
    this.setState({
      selectedTestResult: defaultValue,
      showRestoreConfirm: false,
      isChanged: true,
      isRestore: true
    });
  };

  render() {
    const {
      translate,
      classes,
      languages,
      selectedTest,
      isTestEdit,
      ping4Details,
      ping6Details,
      testEdit,
      modified
    } = this.props;
    const {
      isChanged,
      searchModal,
      pingErrors,
      selectedTestResult,
      subTestTargetResult,
      deleteTargetId,
      isRestore
    } = this.state;

    let $modal = null;
    if (searchModal) {
      $modal = (
        <SearchTarget
          languages={languages}
          modal={searchModal}
          close={this.onTargetSearchClose}
          targetList={subTestTargetResult}
          selectTarget={this.onTargetSearchSelect}
          translate={translate}
          selectedTest={selectedTest.includes("ping4") ? "IPv4" : "IPv6"}
          isTestEdit={isTestEdit}
        />
      );
    }

    return (
      <div style={{marginTop: isTestEdit ? "15px" : "215px"}}>
        {!isTestEdit && (
          <Title
            back={
              !isChanged && (
                <Back
                  link={"/subtestsettings"}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            backCheck={
              isChanged && (
                <BackCheck
                  toCheck={this.onBackClick}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            title={
              selectedTest === "ping4"
                ? translate("general_sub_test_ping4")
                : translate("general_sub_test_ping6")
            }
          />
        )}
        <Content translate={translate}>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              {isTestEdit && (
                <Typography type="headline" className={classes.modalSubHead}>
                  {selectedTest == "ping4"
                    ? translate("general_sub_test_ping4")
                    : translate("general_sub_test_ping6")}
                </Typography>
              )}
              {selectedTestResult && (
                <TextField
                  className={classes.textFieldL}
                  error={pingErrors && pingErrors.count ? true : false}
                  name="count"
                  label={translate("subset_ping_count")}
                  margin="normal"
                  value={selectedTestResult ? selectedTestResult.count : ""}
                  helperText={
                    pingErrors && pingErrors.count ? pingErrors.count : ""
                  }
                  onChange={this.onChange}
                />
              )}
              {selectedTestResult && (
                <TextField
                  className={classes.textFieldL}
                  error={pingErrors && pingErrors.pause ? true : false}
                  name="pause"
                  variant="filled"
                  label={translate("subset_ping_pause")}
                  margin="normal"
                  value={
                    selectedTestResult.targets.length > 1
                      ? "1000"
                      : selectedTestResult
                      ? selectedTestResult.pause
                      : ""
                  }
                  helperText={
                    pingErrors && pingErrors.pause ? pingErrors.pause : null
                  }
                  onChange={this.onChange}
                  disabled={selectedTestResult.targets.length > 1}
                />
              )}
              {selectedTestResult && (
                <TextField
                  className={classes.textField}
                  error={pingErrors && pingErrors.length ? true : false}
                  name="length"
                  label={translate("subset_ping_length")}
                  margin="normal"
                  value={
                    selectedTestResult.targets.length > 1
                      ? "64"
                      : selectedTestResult
                      ? selectedTestResult.length
                      : ""
                  }
                  helperText={
                    pingErrors && pingErrors.length ? pingErrors.length : ""
                  }
                  onChange={this.onChange}
                  disabled={selectedTestResult.targets.length > 1}
                />
              )}
            </Grid>
            {selectedTestResult && (
              <Grid item xs={8}>
                <Grid item xs={8} sm={!isTestEdit ? 8 : 12}>
                  {selectedTestResult &&
                  selectedTestResult.targets &&
                  selectedTestResult.targets.length == 10 ? (
                    <Typography
                      type="subheading"
                      className={classes.lengthText}
                    >
                      {translate("target_limit_validation_text")}
                    </Typography>
                  ) : null}
                  <div className={classes.targetHeading}>
                    <Typography type="title">
                      {translate("sub_set_ping_targets")}
                    </Typography>

                    <Button
                      color="primary"
                      disabled={
                        selectedTestResult &&
                        selectedTestResult.targets &&
                        selectedTestResult.targets.length == 10
                      }
                      onClick={() => this.onTargetAdd()}
                    >
                      <Icon> add </Icon> {translate("subset_ping_add_target")}
                    </Button>
                  </div>

                  {subTestTargetResult &&
                  selectedTestResult &&
                  selectedTestResult.targets.length > 0 ? (
                    selectedTestResult.targets.map((item, key) => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between"
                          }}
                        >
                          <TextField
                            className={classes.textFieldR}
                            key={key}
                            id={item.id}
                            name={item.id}
                            label={
                              translate("sub_set_ping_target") +
                              " " +
                              (key + 1).toString().padStart(2, "0")
                            }
                            placeholder={translate("sub_set_ping_target")}
                            margin="normal"
                            value={item.name ? item.name : ""}
                            onChange={this.onTargetEdit(key)}
                            error={pingErrors && pingErrors[key] ? true : false}
                            helperText={
                              pingErrors && pingErrors[key]
                                ? pingErrors[key]
                                : ""
                            }
                          />
                          <IconButton
                            color="primary"
                            style={{ marginTop: "25px" }}
                            id={item.id}
                            onClick={() => this.onTargetDelete(key)}
                          >
                            <Icon> delete </Icon>
                          </IconButton>
                          <IconButton
                            color="primary"
                            style={{ marginTop: "25px" }}
                            id={item.id}
                            onClick={() =>
                              this.onTargetSearchOpen(item.id, key)
                            }
                          >
                            <Icon> search </Icon>
                          </IconButton>
                        </div>
                      );
                    })
                  ) : (
                    <NoData
                      translate={translate}
                      noDataText="general_sub_test_no_data_target_text"
                    />
                  )}
                  {!isTestEdit && (
                    <div align="right">
                      <Button
                        className={classes.saveTarget}
                        disabled={!isChanged}
                        color="accent"
                        raised
                        mini
                        onClick={() => this.onTargetSave()}
                      >
                        {translate
                          ? translate("sub_set_ping_save_target")
                          : "Save"}
                      </Button>
                    </div>
                  )}
                </Grid>
                {!isTestEdit && <Grid item xs={8} sm={4}></Grid>}
              </Grid>
            )}
          </Grid>

          {$modal}
          <ConfirmDialog
            open={this.state.showConfirmDelete}
            title={translate("sub_test_ping_delete_confirm_title", {
              name: selectedTest
            })}
            contentText={
              this.state.selectedTestResult &&
              this.state.selectedTestResult.targets[deleteTargetId] &&
              this.state.selectedTestResult.targets[deleteTargetId].name &&
              this.state.selectedTestResult.targets[deleteTargetId].name
                .length > 0
                ? translate("sub_test_delete_confirm_text", {
                    url: this.state.selectedTestResult.targets[deleteTargetId]
                      .name
                  })
                : translate("sub_test_delete_empty_confirm_text")
            }
            contentSecondaryText={translate("general_confirmation_help_2")}
            okText={translate("general_confirm")}
            cancelText={translate("general_cancel")}
            onOk={this.onTargetConfirmDelete}
            onCancel={this.hideConfirmModal}
          />
          {!isTestEdit && (
            <ConfirmDialog
              open={this.state.showConfirmBack}
              title={translate("sub_test_ping_delete_confirm_title", {
                name: selectedTest
              })}
              contentText={translate("sub_test_go_back_confirm_text")}
              cancelText={translate("general_cancel")}
              onCancel={this.hideBackConfirmModal}
              yesText={translate("back_btn_yes")}
              noText={translate("back_btn_no")}
              backText={translate("back_btn_go_back")}
              onYes={this.onBackYesClick}
              onNo={this.onBackNoClick}
              onBack={this.hideBackConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.state.showRestoreConfirm}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("restore_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.onRestoreConfirm}
              onCancel={this.hideRestoreConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.props.showCloseConfirm}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("st_test_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.props.onCloseConfirm}
              onCancel={this.props.onCloseCancelConfirmModal}
            />
          )}
        </Content>
        {isTestEdit && selectedTestResult && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "inline-block", marginLeft: "20px" }}>
              {selectedTest === "ping4" ? (
                ping4Details && !testEdit ? (
                  <Button
                    color="primary"
                    onClick={() => this.onResetDetails()}
                    disabled={isRestore}
                    className={classes.restoreButton}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : (
                  testEdit &&
                  modified && (
                    <Button
                      color="primary"
                      onClick={() => this.onResetDetails()}
                      disabled={isRestore}
                      className={classes.restoreButton}
                    >
                      <Icon> restore </Icon>{" "}
                      {translate("restore_default_settings")}
                    </Button>
                  )
                )
              ) : ping6Details && !testEdit ? (
                <Button
                  color="primary"
                  onClick={() => this.onResetDetails()}
                  disabled={isRestore}
                  className={classes.restoreButton}
                >
                  <Icon> restore </Icon> {translate("restore_default_settings")}
                </Button>
              ) : (
                testEdit &&
                modified && (
                  <Button
                    color="primary"
                    onClick={() => this.onResetDetails()}
                    disabled={isRestore}
                    className={classes.restoreButton}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                )
              )}
              {/* {showRestore == false && isChanged  ? <Button color="primary" onClick={this.props.handleClose}>
                <Icon>navigate_before</Icon>
                {translate("tooltip_back")}
              </Button>:null} */}
            </div>
            <div style={{ display: "inline-block", marginRight: "20px" }}>
              <Button
                className={classes.saveTarget}
                disabled={!isChanged}
                color="accent"
                raised
                onClick={() => this.onTargetSave()}
              >
                {translate("general_continue")}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }
}

export default withRouter(withStyles(styles)(Ping));



// WEBPACK FOOTER //
// ./src/components/subtestsetting/ping/index.js